export const PRODUCTION_FORM_FIELDS = [
  {
    id: "name",
    label: "Название",
    placeholder: "Введите название площадки",
  },
  {
    id: "address",
    label: "Адрес",
    placeholder: "Введите адрес площадки",
  },
  {
    id: "contact",
    label: "ФИО контактного лица",
    placeholder: "Введите ФИО",
  },
  {
    id: "phone",
    label: "Телефон",
    placeholder: "Введите телефон",
  },
];
